// extracted by mini-css-extract-plugin
export default {"ordersCard":"SingleToOrder_ordersCard__qBdbm","orderRow":"SingleToOrder_orderRow__6c1lS"};